import React from 'react';
import axios from 'axios';
import { Alert, Row, Col, Input } from 'antd';

import apiPath from 'apiPath';
import moment from 'components/momentWithZone';
import TransactionTable from 'components/TransactionTable';
import PaymentTriggerForm from 'components/PaymentTriggerForm';

export default class FieldPayment extends React.Component {
	state = {
		amount: null,
		chargeTotal: null,
		creditTotal: null,
		bookingID: null,
		fieldPrograms: [],
		fieldTransactions: [],
		fieldPayments: [],
		detailsLoaded: false,
		childDiscount: false
	}
	loadFieldPrograms = () => {
		axios.get(apiPath+'/fieldprograms').then(result => {
			this.setState({ fieldPrograms: result.data });
		}).catch(error => {
			console.error(error);
			this.setState({ fieldPrograms: [] });
		});
	}
	preCheckout = () => {
		return new Promise((resolve, reject) => {
			if (!isNaN(this.refs.amount.value) && this.refs.amount.value > 0) {
				resolve();
			} else {
				reject({message: 'Invalid payment amount'});
			}
		});
	}

	checkForDiscounts = () => {
		axios.get(apiPath+'/ischild', {withCredentials: true}).then(result => {
			if (result.data === true) {
				this.setState({ childDiscount: true });
			}
		}).catch(this.props.handleAxiosLoadError);
	}

	getTransactionDetails = (props) => {
		window.clearTimeout(this._timeout);
		if (this.state.fieldPrograms.length > 0) {
			let fieldTransactions = props.fieldTransactions.slice().filter(t => t.Amount !== '.0000');
			let bookedItems = props.bookedItems.slice();
			bookedItems.map(item => {
				let matchIndex = fieldTransactions.findIndex(t => {
					return t.Amount === item.Amount && !t.used }
				);
				if (matchIndex !== -1) {
					fieldTransactions[matchIndex].used = true;
					const fieldProgram = this.state.fieldPrograms.find(p => {
						return p.ItemId == item.ItemId
					});
					if (fieldProgram) {
						fieldTransactions[matchIndex].Name = fieldProgram.Name;
					}
				}
			});
			const GSCEItem = bookedItems.find(item => typeof item !== 'undefined' && item.Comments === 'GSCE - DO NOT CHARGE');
			if (GSCEItem) {
				const fieldProgram = this.state.fieldPrograms.find(p => p.ItemId == GSCEItem.ItemId);
				let name = 'GSCE Program';
				if (fieldProgram) name = fieldProgram.Name;
				fieldTransactions.push({
					Amount: ".0000",
					BaseMessage: "GSCE Program",
					Charge: ".0000",
					ItemId: GSCEItem.ItemId,
					Name: name,
					id: 'GSCE'
				});
			}
			this.setState({ fieldTransactions: fieldTransactions });
		} else {
			this._timeout = window.setTimeout(() => this.getTransactionDetails(props), 500);
		}
	}
	getBalance = (props) => {
		if (props.bookingLoaded) {
			this.setState({
				chargeTotal: props.fieldChargeTotal,
				creditTotal: props.fieldCreditTotal,
				fieldPayments: props.fieldPayments,
				fieldTransactions: props.fieldTransactions
			});
			this.getTransactionDetails(props);
		}
	}
	formatDollarAmount = (amount) => parseFloat(Math.round((amount) * 100) / 100).toFixed(2)
	componentDidMount() { this.loadFieldPrograms(); this.getBalance(this.props); this.checkForDiscounts();}
	componentWillReceiveProps(nextProps) { this.getBalance(nextProps); }
	render() {
		const disabled = this.props.variant !== 'admin' && !this.props.sectionIsEnabled(this.props, 'financial/fieldpayment');
		if (this.props.variant !== 'admin' && this.props.redirectIfHidden) {
			const redirect = this.props.redirectIfHidden(this.props, 'financial/fieldpayment');
			if (redirect) return redirect;
		}
		const rule = this.props.configRules && this.props.configRules.find(rule => rule.section === 'financial/fieldpayment');
		const beforeEnabled =
			(this.props.variant === 'admin')? false:
			(!rule)? true:
			(rule.enableAlways === "1")? false:
			moment().isBefore(moment.utc(rule.enableFrom));
		const deadlinePassed =
			(this.props.variant === 'admin')? false:
			(!rule)? false:
			(rule.enableAlways === "1")? false:
			moment().isAfter(moment.utc(rule.disableAfter));
		const temporarilyDisabled = false;
		const overrideDisabled = this.props.folio && this.props.folio.FolioId === '115'; // Sue Test

		let { chargeTotal, creditTotal } = this.state;
		let amount = this.state.amount || 0;
		if (amount > chargeTotal - creditTotal) amount = chargeTotal - creditTotal;
		return (
			<div>
				{moment().isBefore('2018-06-14T09:00:00') &&
					<Alert type="info"
						description="Field Program payments will begin being accepted on June 14th. All programs booked during the initial open-registration period must be
						paid in full by June 25th. On June 26th, all unpaid Field Programs will be cancelled. After that date, any new program registrations require payment at time of booking." />
				}
				<Alert showIcon type="info"
					description={<span>
						{/* ​Payment is due at the time of registration. ​Payment options include e-check or credit / debit card. The  2.7% service fee is WAIVED on Field Program payments. 
						<br /><br /> */}
						"If you would like a PDF receipt of Field Program purchases, email us at <a href="mailto:Field@isevoyages.org">Field@isevoyages.org</a>.  
					</span>}/>
				<br />
				{!deadlinePassed && moment().isBefore('2018-11-13') &&
							<Alert showIcon
								type="info"
								message="Upcoming Deadlines"
								description={<span>
									<strong style={{color: "red"}}>November 13</strong> 12:01 AM Mountain time: 
									<ul style={{paddingLeft:'8pt', listStyleType:'circle'}}>
										<li><strong>Payment deadline:</strong> All programs booked during the initial open-registration period must be paid in full by the end of the day, November 12th. On November 13th, all unpaid Field Programs will be cancelled. All new registrations after this date require payment at the time of booking.</li>
										<li><strong>End early-booking pricing:</strong> Beginning on November 13th, the standard booking rate applies to all new registrations.</li>
										<li><strong>End cancellation grace period:</strong> Any cancellations processed November 13th and beyond are subject to penalty.</li>
									</ul>
									<br /> 
									Review registration deadlines and cancellation policies <a href="http://2xj3ep1sacqvsluiw1w0g438-wpengine.netdna-ssl.com/wp-content/uploads/2018/09/Important-Dates-and-Deadlines_SP19.pdf" target="blank">here</a>
								</span>} />
				}
				<br />
				{this.props.bookingLoaded && chargeTotal === creditTotal && creditTotal !== null &&
					<Alert showIcon type="success"
						message="You're all set"
						description="Looks like all of your field programs have been paid for" />
				}
				{chargeTotal < creditTotal &&
					<Alert showIcon type="success"
						message="You have Field Program credit on your account"
						description={'Your balance is $'+this.formatDollarAmount(creditTotal - chargeTotal)} />
				}
				{/* {chargeTotal > creditTotal && !deadlinePassed && !beforeEnabled && (!temporarilyDisabled || overrideDisabled) && moment().isAfter('2018-10-31T09:00') && */}
				{chargeTotal > creditTotal &&
					<Alert showIcon type="warning"
						message={'You owe $'+this.formatDollarAmount(chargeTotal - creditTotal)+' toward Field Programs'}
						description={
							<Row>
								<Col span={16}>
									<input type="hidden" ref="amount" name="amount" value={parseFloat(Math.round(amount * 100) / 100).toFixed(2)} />
									<Input
										prefix="$"
										onChange={(e) => this.setState({amount:e.target.value})}
										onBlur={(e) => {
											if (!isNaN(parseFloat(Math.round(amount * 100) / 100).toFixed(2))) {
												e.target.value = parseFloat(Math.round(amount * 100) / 100).toFixed(2)
											}
										}}
										defaultValue={parseFloat(Math.round(amount * 100) / 100).toFixed(2)} />
								</Col>
								<Col span={8}>
									<PaymentTriggerForm showIcon
										kickSession={this.props.kickSession}
										disabled={disabled}
										buttonText="Make a Payment"
										orderno_prefix="FLD"
										preCheckout={this.preCheckout}
										refreshBooking={this.props.refreshBooking}
										cust_id={this.props.folio.RepeaterNo}
										booking={this.props.bookingLoaded && this.props.booking}
										client_email={this.props.folio.Email1}
										total={amount} />
								</Col>
							</Row>
						} />
				}

				
				{/* {chargeTotal > creditTotal && (deadlinePassed || beforeEnabled || temporarilyDisabled) &&
					<Alert showIcon type="warning"
						description={(temporarilyDisabled)? 'Field payments are currently temporarily disabled. You can make a payment on your Field Programs beginning tomorrow (24 October).':'Online payments cannot be made at this time'} />
				} */}

				{moment().isBefore('2018-10-31T09:00') &&
					<Alert showIcon type="warning"
						description={'Field payments are currently temporarily disabled. You can make a payment on your Field Programs beginning tomorrow (31 October).'} />
				}
				<br />
				<TransactionTable
					variant={this.props.variant}
					chargeTotal={chargeTotal}
					creditTotal={creditTotal}
					transactions={
							this.state.fieldTransactions
							.map(t => { t.Charge = (t.Amount); return t; })
							.concat(this.state.fieldPayments.map(p => { p.Payment = p.Amount; return p; }))
							.sort((a,b) => a.id - b.id)
					} />
					{/* (this.state.childDiscount === true ?
						this.state.fieldTransactions
							.map(t => { t.Charge = (t.Amount/2); return t; })
							.concat(this.state.fieldPayments.map(p => { p.Payment = p.Amount; return p; }))
							.sort((a,b) => a.id - b.id) : 
							this.state.fieldTransactions
							.map(t => { t.Charge = (t.Amount); return t; })
							.concat(this.state.fieldPayments.map(p => { p.Payment = p.Amount; return p; }))
							.sort((a,b) => a.id - b.id)
						) */}
			</div>
		);
	}
}


// WEBPACK FOOTER //
// ./portal-components/Portal/Financial/FieldPayment.jsx